// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"22c0cdcd","453":"69f30bfb","732":"640404d6","977":"22671858"}[chunkId] + ".chunk.js";
};